import {Component, Inject, OnInit} from '@angular/core';

import {AlertService, AuthenticationService,} from '../../_services/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {DictionaryService} from "../../_services/dictionary.service";
import {LoginHelper} from "../../helpers";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import { Constants } from '../../helpers/constants';

@Component({
    standalone: false,
  selector: 'editdictionaryitem-component',
  templateUrl: 'editDictionaryItem.component.html',
  styleUrls: ['./editDictionaryItem.component.css'],
})

export class EditDictionaryItemComponent implements OnInit {
  dictionaryItem: DictionaryItem;
  logoUrl?: string;
  dictionaryItemId: number;
  form: FormGroup;
  visibility: any = {};
  parents: DictionaryItem[] = [];
  topics: DictionaryItem[];
  constants = Constants;

  constructor(
    public dialogRef: MatDialogRef<EditDictionaryItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public dictionaryService: DictionaryService,
    public alertService: AlertService,
    public formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.dictionaryItem = this.data.dictionaryItem || new DictionaryItem();
    this.parents = this.data.parents;
    this.setLogoUrl();
    this.dictionaryService.get(['Topic']).subscribe(t => this.topics = t);
    this.form = this.formBuilder.group({
      itemId: [0],
      name: ['', Validators.required],
      topic: [''],
      securityTopic: [''],
      parentId: [null],
      dictionary: [''],
      details: [''],
      supportingFeatures: [''],
      inheritance: [''],
      fulfillmentMethod: [''],
      url: [''],
      guidance: [''],
      lastUpdated: [''],
      details2: [''],
      configInfo: [''],
      customerResponsibilities: [''],
      price: [''],
      contact: [''],
      configDetails: [''],
    });
    this.form.setValue({
      itemId: this.dictionaryItem.itemId || null,
      name: this.dictionaryItem.name || null,
      topic: this.dictionaryItem.topic || null,
      securityTopic: this.dictionaryItem.securityTopic || null,
      parentId: this.dictionaryItem.parentId || null,
      dictionary: this.dictionaryItem.dictionary || null,
      details: this.dictionaryItem.details || null,
      supportingFeatures: this.dictionaryItem.supportingFeatures || null,
      inheritance: this.dictionaryItem.inheritance || null,
      fulfillmentMethod: this.dictionaryItem.fulfillmentMethod || null,
      url: this.dictionaryItem.url || null,
      guidance: this.dictionaryItem.guidance || null,
      lastUpdated: this.dictionaryItem.lastUpdated || null,
      details2: this.dictionaryItem.details2 || null,
      customerResponsibilities: this.dictionaryItem.customerResponsibilities || null,
      configInfo: this.dictionaryItem.configInfo || null,
      price: this.dictionaryItem.price || null,
      contact: this.dictionaryItem.contact || null,
      configDetails: this.dictionaryItem.configDetails || null
    });
  }

  onSave() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }

    this.alertService.clear();

    this.dictionaryService.save({...this.form.value, logoFileName: this.dictionaryItem.logoFileName, dictionaryControlItems: this.dictionaryItem.dictionaryControlItems})
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  onClose(): void {
    this.dialogRef.close(this.dictionaryItem);
  }

  onDelete() {
    this.alertService.clear();

    this.dictionaryService.delete(this.dictionaryItem.itemId)
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  setLogoUrl() {
    this.logoUrl = '/api/attachments/file?name=' + encodeURIComponent(this.dictionaryItem.logoFileName) + '&path=Account/Dictionaries/' + '&token=' + LoginHelper.getFileToken()
  }

  public addLogo(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.dictionaryService.uploadLogo(attachments[0])
        .subscribe(data => {
          this.dictionaryItem.logoFileName = data.result;
          this.setLogoUrl();
        });
    }
  }

  addControlItem() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: []
      }
    };

    const selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.dictionaryItem.dictionaryControlItems = this.dictionaryItem.dictionaryControlItems || [];
        this.dictionaryItem.dictionaryControlItems.push({
          controlItemId: data.controlItemId,
          complianceAreaName: data.complianceAreaName,
          complianceAreaControlId: data.complianceAreaControlId,
        });
      }
    });
  }

  detachControlItem(item) {
    this.dictionaryItem.dictionaryControlItems = this.dictionaryItem.dictionaryControlItems.filter((i) => i !== item);
  }
}
